
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"24","height":"24"}},[_c('path',{attrs:{"d":"M12.14 5.85a1.54 1.54 0 001.5-1.5 2.41 2.41 0 00-.2-.8l-1.3-2.2-1.3 2.3a1.86 1.86 0 00-.2.8A1.38 1.38 0 0012 5.85zm6.5 2.7h-5.4v-2.2H11v2.2H5.64a3.33 3.33 0 00-3.3 3.3v1.7a2.11 2.11 0 002.1 2.1 2 2 0 001.5-.6l2.3-2.3 2.3 2.3a2.18 2.18 0 003 0l2.3-2.3 2.3 2.3a2 2 0 001.5.6 2.11 2.11 0 002.1-2.1v-1.7a3.1 3.1 0 00-2.9-3.29z"}}),_c('path',{attrs:{"d":"M17 16.65l-1.2-1.2-1.2 1.2a3.87 3.87 0 01-5.3 0l-1.2-1.2-1.2 1.2a3.63 3.63 0 01-2.6 1.1 3.14 3.14 0 01-2.1-.7v4.5a1.12 1.12 0 001.1 1.1h17.3a1.11 1.11 0 001.1-1.1v-4.5a3.57 3.57 0 01-4.7-.4z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      